<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Bank" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<g id="ico-bank-copy" transform="translate(1.76, 1.76)" :fill="color" fill-rule="nonzero">
						<path d="M27.4689603,31.8064923 L27.4689603,14.456365 L21.687659,14.456365 L21.687659,31.8049364 L27.4689603,31.8064923 L27.4689603,31.8064923 Z M36.1455797,31.8064923 L36.1455797,14.456365 L30.3611669,14.456365 L30.3611669,31.8049364 L36.1455797,31.8064923 L36.1455797,31.8064923 Z M39.0362305,11.0523049 L20.2423338,0 L1.44688113,11.0523049 C1.44688113,11.0523049 0.149355466,12.2207003 1.44688113,13.0125954 L39.0362305,13.0125954 C39.0362305,13.0110396 40.0879419,12.1522457 39.0362305,11.0523049 Z M18.7970084,31.8064923 L18.7970084,14.456365 L13.0110396,14.456365 L13.0110396,31.8049364 L18.7970084,31.8064923 L18.7970084,31.8064923 Z M10.1203889,31.8064923 L10.1203889,14.456365 L4.33753181,14.456365 L4.33753181,31.8049364 L10.1203889,31.8064923 L10.1203889,31.8064923 Z M37.7698205,33.8492394 L3.17691533,33.9441423 L0,38.0965357 L0,40.4831115 L40.48,40.4831115 L40.48,38.0965357 L37.7698205,33.8492394 Z" id="path-1"></path>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>